import { createSlice } from '@reduxjs/toolkit'
import { BookingsState } from 'src/@types/calendar'
import authSlice from '../auth/slice'

const initialState: BookingsState = {
  isLoading: false,
  isBookingsLoading: false,
  isBookingLocationsLoading: false,
  isBlockTimesLoading: false,
  isFreestyleRentalsLoading: false,
  isVehiclesLoading: false,
  error: null,
  bookings: [],
  freestyleRentals: [],
  blockTimes: [],
  vehicles: [],
  filters: {
    cars: [],
    bookingLocations: [],
    countries: [],
    availability: 'All',
  },
  bookingLocations: [],
  isOpenModal: false,
  selectedBookingId: null,
  selectedRange: null,
}

const bookingsSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true
    },

    stopLoading(state) {
      state.isLoading = false
    },

    startBookingsLoading(state) {
      state.isBookingsLoading = true
    },

    startBlockedTimesLoading(state) {
      state.isBlockTimesLoading = true
    },

    startFreestyleRentalsLoading(state) {
      state.isFreestyleRentalsLoading = true
    },

    startVehiclesLoading(state) {
      state.isVehiclesLoading = true
    },

    startBookingLocationsLoading(state) {
      state.isBookingLocationsLoading = true
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.isBookingsLoading = false
      state.isBookingLocationsLoading = false
      state.isBlockTimesLoading = false
      state.isFreestyleRentalsLoading = false
      state.isVehiclesLoading = false
      state.error = action.payload
    },

    // GET BOOKING LOCATIONS
    getBookingLocationsSuccess(state, action) {
      state.isBookingLocationsLoading = false
      state.bookingLocations = action.payload
    },

    // GET VEHICLE LIST
    getVehicleListSuccess(state, action) {
      state.isVehiclesLoading = false
      state.vehicles = action.payload
    },

    // GET BOOKINGS
    getBookingsSuccess(state, action) {
      state.isBookingsLoading = false
      state.bookings = action.payload
    },

    // GET BLOCK TIMES
    getBlockTimesSuccess(state, action) {
      state.isBlockTimesLoading = false
      state.blockTimes = action.payload
    },

    // GET FREESTYLE RENTALS
    getFreestyleRentalsSuccess(state, action) {
      state.isFreestyleRentalsLoading = false
      state.freestyleRentals = action.payload
    },

    // SELECT BOOKING
    selectBooking(state, action) {
      const bookingId = action.payload
      state.isOpenModal = true
      state.selectedBookingId = bookingId
    },

    // SELECT RANGE
    selectRange(state, action) {
      const { start, end } = action.payload
      state.isOpenModal = true
      state.selectedRange = { start, end }
    },

    // OPEN MODAL
    openModal(state) {
      state.isOpenModal = true
    },

    // CLOSE MODAL
    closeModal(state) {
      state.isOpenModal = false
      state.selectedBookingId = null
      state.selectedRange = null
    },

    filterBookings(state, action) {
      state.filters.cars = action.payload.cars
      state.filters.countries = action.payload.countries
      state.filters.bookingLocations = action.payload.bookingLocations
      state.filters.availability = action.payload.availability
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authSlice.actions.signOut, (state) => {
      return initialState
    })
  },
})

// Reducer
export default bookingsSlice
